import { ArrowPointLeft } from "assets/icons/Common";
import { HorizontalLine, IconButton, Row } from "components/primitives";
import { FC } from "react";
import styled from "styled-components";

interface Props {
  header: string;
  onBack: () => void;
}

export const ToolbarSegmentHeader: FC<Props> = ({ header, onBack }) => {
  return (
    <>
      <HeaderRow>
        <BackButton Icon={ArrowPointLeft} withShadow={false} onClick={onBack} />
        <p>{header}</p>
      </HeaderRow>
      <HorizontalLine />
    </>
  );
};

const HeaderRow = styled(Row)`
  width: 100%;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;

  p {
    color: var(--secondary);
    font-weight: 600;
    font-size: 1.5em;
  }
`;

const BackButton = styled(IconButton)`
  width: 30px;
  padding: 8px;
`;
